module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/30739a9d6fe024c005411f96dfbdfcd1.png";